module.exports = __webpack_public_path__ + "img/if_12.753fd1bb.png";